import {authConfig} from 'lib/auth-config';

const NETWORK_AUTH_MESSAGE = 'Okta discovery request failed (network, CORS, or aborted request).';

export function isAnonymousAuth(error) {
  return error?.errorCode === 'login_required';
}

export function describeAuthError(error) {
  const issuer = authConfig.issuer;

  if (!error) {
    return {
      name: 'UnknownError',
      message: NETWORK_AUTH_MESSAGE,
      errorCode: undefined,
      errorSummary: undefined,
      xhrStatus: undefined,
      issuer,
    };
  }

  const xhrStatus = error.xhr?.status ?? error.status;
  const errorSummary = error.errorSummary;
  const rawMessage = error.message || errorSummary;
  const message =
    rawMessage && String(rawMessage).trim() ? String(rawMessage) : NETWORK_AUTH_MESSAGE;

  return {
    name: error.name || 'Error',
    message,
    errorCode: error.errorCode,
    errorSummary,
    xhrStatus,
    issuer,
  };
}
